import { KLEUR_PALET } from '@/lib/screenColors'

/* Compacte color-picker: swatch-rij + native picker + reset. `value` is
   een hex-string of leeg. `defaultColor` toont visueel wat er staat als je
   niks kiest (bijv. de LED-swatch of de kind-standaard). */
export default function ColorPicker({ value, onChange, defaultColor, label }) {
  const effectief = value || defaultColor || '#94a3b8'
  return (
    <div>
      {label && (
        <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-1">
          {label}
        </div>
      )}
      <div className="flex items-center gap-2 flex-wrap">
        <input type="color" value={effectief}
               onChange={e => onChange(e.target.value)}
               className="h-8 w-10 rounded-[4px] border border-border cursor-pointer bg-transparent p-0" />
        <input type="text" value={value ?? ''} onChange={e => onChange(e.target.value)}
               placeholder={defaultColor ? `${defaultColor} (standaard)` : '#RRGGBB'}
               className="flex-1 min-w-[8rem] rounded-[4px] border border-border bg-background px-2 py-1 text-sm font-mono" />
        <button type="button" onClick={() => onChange('')}
                className="text-xs text-muted-foreground hover:text-foreground underline">
          reset
        </button>
      </div>
      <div className="flex gap-1 flex-wrap mt-2">
        {KLEUR_PALET.map(c => (
          <button key={c} type="button" title={c}
                  onClick={() => onChange(c)}
                  className="h-6 w-6 rounded-[3px] border border-border shrink-0 hover:scale-110 transition-transform"
                  style={{
                    background: c,
                    outline: (value ?? '').toLowerCase() === c.toLowerCase() ? '2px solid var(--acid, #B4FF39)' : 'none',
                    outlineOffset: '1px',
                  }} />
        ))}
      </div>
    </div>
  )
}
